/**
 * @author Brendan Magee
 * @desc Component for adding a story to collections via iframe
 * @example <collections-modal
 *              resolve="{ storyId, storyWebsite }"
 *              modalInstance="$uibModalInstance">
 *          </collections-modal>
 */

const template = `<div class="height-75vh">
                    <iframe class="min-width-100"
                            id="external-iframe"
                            ng-if="$ctrl.src" 
                            ng-src="{{ $ctrl.src }}"
                            frameborder="0">
                    </iframe>
                    <div class="min-height-2 min-width-100 flexbox flex-justify-end pv1">
                      <button class="btn btn-primary"
                              ng-click="$ctrl.modalInstance.close()"
                              twp-translate>
                        CLOSE_V
                      </button>
                    </div>
                  </div>`;

class CollectionsModalController {
  constructor($sce, featureFlag) {
    this.$sce = $sce;
    this.featureFlag = featureFlag;
  }

  $onInit() {
    let srcUrl;
    if (this.resolve.storyWebsite) {
      srcUrl = `/websked/collections/iframe/contents/${this.resolve.storyId}/${this.resolve.storyWebsite}`;
    } else {
      srcUrl = `/websked/collections/iframe/contents/${this.resolve.storyId}`;
    }
    this.src = this.$sce.trustAsResourceUrl(srcUrl);
  }
}

const arr = ['$sce', 'featureFlag', CollectionsModalController];

const collectionsModal = {
  template,
  controller: 'CollectionsModalController',
  bindings: {
    resolve: '<',
    modalInstance: '<'
  }
};

export default function (ngModule) {
  ngModule.component('collectionsModal', collectionsModal);
  ngModule.controller('CollectionsModalController', arr);
}
